import axios from "axios";

const instance = axios.create({
  baseURL: "https://join.mmbaicindia.com/api/ApiCommonController/",
});

export default instance;
